import React from 'react'
import { Grid2, Skeleton, useTheme } from '@mui/material'
import GridRow from './GridRow'
const GridBody = ({
  columns,
  data,
  onClick,
  multiSelectedItemOptions,
  getSelectedItemOptions,
  handleSetSelectedItems,
  selectedItems,
  getItemOptions,
  pageLength
}) => {


  let content;
  let empty;
  const gridHeight = 56;
  const theme = useTheme()
  if (data) {
    content = data.items.map((x, i) => (
      <GridRow
        gridHeight={gridHeight}
        item={x}
        columns={columns}
        multiSelectedItemOptions={multiSelectedItemOptions}
        getSelectedItemOptions={getSelectedItemOptions}
        onClick={onClick ? () => onClick(x) : null}
        handleSetSelectedItems={handleSetSelectedItems}
        selectedItems={selectedItems}
        key={i}
        getItemOptions={getItemOptions}
      />
    ));
    if (data.items.length < 11) {
      const amount = [];
      for (let i = data.items.length; i < pageLength; i++) {
        amount.push(i);
      }
      empty = amount.map((x, i) => (<Skeleton animation={false} key={i} style={{
        borderBottom: `1px solid ${theme.palette.mode === 'dark'
          ? theme.palette.primary.dark
          : theme.palette.primary.light
          }`,
        background: "none"
      }}

        variant="rectangular"
        height={gridHeight}
        width={"100%"}
      />))
    }
  } else {

    const amount = [];
    for (let i = 0; i < pageLength; i++) {
      amount.push(i);
    }
    content = amount.map((x, i) => (<Skeleton key={i} style={{
      borderBottom: `1px solid ${theme.palette.mode === 'dark'
        ? theme.palette.primary.dark
        : theme.palette.primary.light
        }`,
      height: gridHeight,
      paddingBottom: theme.spacing(1),
    }} variant="rectangular" height={"32"} />))

  }

  return (
    <Grid2 >
      {content}
      {empty}
    </Grid2>
  )
}

export default GridBody
